module.exports = __webpack_public_path__ + "static/media/01.cb472949.png";